import React from "react";

function CardFeatureContent({
  cardFeatureTitle,
  cardFeatureSummary,
  cardFeatureIcon,
}) {
  return (
    <div className="card-block col">
      <div className="card-icon">{cardFeatureIcon}</div>
      <div className="card-block-text">
        <h5 className="cb-title">{cardFeatureTitle}</h5>
        <p className="cb-summary">{cardFeatureSummary}</p>
      </div>
    </div>
  );
}

export default CardFeatureContent;
